import { type FunctionComponent } from 'react';
import { configureRoute } from '../../../../utils/routes/configure-route';
import { PageContainer } from '../../../components/common-components/page/page-container/page-container.component';
import { AboutPageFAQ } from '../../../components/project-components/projects-about/about-page-faq/about-page-faq.component';
import { AboutPageHeader } from '../../../components/project-components/projects-about/about-page-header/about-page-header.component';
import { AboutPageInpiration } from '../../../components/project-components/projects-about/about-page-inspiration/about-page-inspiration.component';
import { AboutPagePromoVideo } from '../../../components/project-components/projects-about/about-page-promo-video/about-page-promo-video.component';
import { AboutPageTools } from '../../../components/project-components/projects-about/about-page-tools/about-page-tools.component';
import { ShowroomExperienceBackground } from '../../../components/showroom-components/showroom-experience/showroom-experience-background/showroom-experience-background.component';
import { ShowroomMeetExpert } from '../../../components/showroom-components/showroom-meet-expert/showroom-meet-expert.component';
import { MAX_PAGE_WIDTH } from '../../../constants/breakpoints';
import { PROJECT_ABOUT_LINK, SHOWROOM_SEARCH_LINK } from '../../../constants/links';
import { PROJECTS_ABOUT_DESCRIPTION_META, PROJECTS_ABOUT_TITLE_META } from '../../../constants/meta';
import { VISIT_SHOWROOM_CARD_TITLE, VISIT_SHOWROOM_CARD_COPY } from '../../../constants/project/about-page';
import { useTrackPageView } from '../../../hooks/analytics/analytics.hooks';
import { useNavigation } from '../../../hooks/navigation/navigation.hooks';

export const ProjectAboutPage: FunctionComponent = () => {
	const pageName = 'projects:projectsabout';
	useTrackPageView({ pageName }, { page: pageName });
	const navigate = useNavigation();

	const onLocationSearch = (input: string): void => {
		const searchByLocationLink = `${SHOWROOM_SEARCH_LINK}?searchTerm=${input}`;
		navigate(searchByLocationLink);
	};

	return (
		<section
			aria-label="about the project tool"
			className="flex flex-column items-center gr5 gr6-ns w-100 ph0"
			data-testid="project-about-page">
			<PageContainer
				canonicalURL={PROJECT_ABOUT_LINK}
				pageTitle={PROJECTS_ABOUT_TITLE_META}
				metaDescription={PROJECTS_ABOUT_DESCRIPTION_META}
				layout="minimized">
				<AboutPageHeader />
			</PageContainer>
			<div className="relative w-100">
				<AboutPageTools />
				<AboutPagePromoVideo />
				<ShowroomExperienceBackground blurBothEnds={true} />
			</div>
			<AboutPageInpiration />
			<section className="flex justify-center w-100 mt5">
				<div className="w-100" style={{ maxWidth: MAX_PAGE_WIDTH }}>
					<ShowroomMeetExpert
						backgroundColor="primary-lighter"
						searchOnClick={onLocationSearch}
						cardTitle={VISIT_SHOWROOM_CARD_TITLE}
						cardCopy={VISIT_SHOWROOM_CARD_COPY}
					/>
				</div>
			</section>
			<AboutPageFAQ />
		</section>
	);
};

export const RoutedProjectAbout = configureRoute({ path: PROJECT_ABOUT_LINK }, ProjectAboutPage);
